import { useState } from 'react';

export const useTextOnScene = () => {
  const [activeTextSceneButton, setActiveTextSceneButton] = useState(0);

  const slideLength = (activeTextSceneButton + 1) * 100;

  return [slideLength, activeTextSceneButton, setActiveTextSceneButton] as const;
};
